import './headline.scss'
import type { GridElement } from '@omnia/ui/src/lib/cms/grid/interfaces/gridElement'
import { type FC, memo } from 'react'

export const Headline: FC<GridElement<string>> = memo(
    props => {
        return <h2 className="headline">{props.value}</h2>
    },
    (p, n) => p.value === n.value
)
